const MinusIcon = () => (
  <svg width="30" height="4" viewBox="0 0 30 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M29.6666 0.166504H0.333252V3.83317H29.6666V0.166504Z" fill="#010101" />
  </svg>)

export default MinusIcon;